// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1iTpf","content":"GlobalSearch_content__oDuZ6"};